<div id="errorModal">
  <div class="modal-content">
    <div class="modalContainer">
      <form action="">
        <div class="cardModalTitle">
          <h4>{{ title }}</h4>
          <span
            class="close"
            mat-raised-button
            mat-dialog-close
            (click)="closeErrorIntern()"
          >
            <img src="assets/img/close-white.svg" alt="" />
          </span>
        </div>
        <div class="cardModalContent">
          <p class="error-description">
            {{
              showErrorIbanFraude()
                ? ''
                : 'Le service est momentanément indisponible'
            }}
          </p>
        </div>
        <div class="content-text">
          <div class="text-poursuivre">
            Pour poursuivre votre souscription, <br />veuillez contacter un
            conseiller au numéro suivant :
          </div>
        </div>
        <br />
        <div class="txtMilieu">
          <div class="phone-div">
            <img src="assets/img/phone2.svg" alt="te" />
            <p class="phone-number">01 87 52 78 79</p>
          </div>
          <!-- <p class="text-phone">Appel & Service gratuit · Lundi au vendredi de 9h à 19h</p> -->
        </div>
      </form>
    </div>
  </div>
</div>
